import ru from 'date-fns/locale/ru'
import format from 'date-fns/format'
import parseISO from 'date-fns/parseISO'
import utcToZonedTime from 'date-fns-tz/utcToZonedTime'

/**
 * Отформатировать дату
 * @param {Date} Дата
 * @param {String} Формат даты
 * @returns {String} Дата
 */
export function formatDate (date, token) {
  return format(date, token, { locale: ru })
}

/**
 * Спарсить и отформатировать дату
 * @param {Date} Дата
 * @param {String} Формат даты
 * @returns {String} Дата
 */
export function parseFormatDate (date, token) {
  const parsedDate = parseISO(date)
  return formatDate(parsedDate, token)
}

/**
 * Получить текущую дату
 * @param {Date} Дата
 * @param {String} Формат даты
 * @param {String} Часовой пояс
 * @returns {String} Дата
 */
export function getCurrentDate (date, token, timezone = 'Asia/Kamchatka') {
  const zonedDate = utcToZonedTime(date, timezone)

  return formatDate(zonedDate, token)
}

/**
 * Склонение числительный
 * @param {Number} Дата
 * @param {Array} Массив заголовков
 * @returns {String} Итоговый текст
 */
export function declOfNum (value, titles) {
  const cases = [2, 0, 1, 1, 1, 2]
  return `${value} ${titles[(value % 100 > 4 && value % 100 < 20) ? 2 : cases[(value % 10 < 5) ? value % 10 : 5]]}`
}

/**
 * Предзагрузка изображений
 * @param {Array} imagesArray
 */
export function loadImage (imagesArray, field) {
  imagesArray.forEach((item) => {
    const img = new Image()
    img.src = item[field]
  })
}
